import { render } from "./TendersList.vue?vue&type=template&id=df708b90"
import script from "./TendersList.vue?vue&type=script&lang=js"
export * from "./TendersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Tenders/TendersList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df708b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df708b90', __exports__)) {
    api.reload('df708b90', __exports__)
  }
  
  module.hot.accept("./TendersList.vue?vue&type=template&id=df708b90", () => {
    api.rerender('df708b90', render)
  })

}


export default __exports__